import React from "react";
import { SeasonGameLog } from "../../../../types/LogTypes";
import { useParams } from "react-router-dom";
import { useLogger } from "../../../../contexts/LoggerContext";
import { Box, Stack, Typography } from "@mui/material";
import { QuickNavigation } from "../Components/QuickNavigation";
import { SectionContainer } from "../Components/SectionContainer";
import { GameTeam } from "./GameTeam";
import { calculateSeasonStats } from "../helpers";
import { Passing } from "../Components/Passing";
import { Rushing } from "../Components/Rushing";
import { Receiving } from "../Components/Receiving";
import { useClub } from "../../../../contexts/ClubContext";
import { Defense } from "../Components/Defense";

export const GameStats = () => {
  const { gameLogId } = useParams();
  const { gameLogs } = useLogger();
  const { club } = useClub();
  const gameLog = gameLogs?.find(
    (gameLog) => gameLog.id === parseInt(gameLogId as string)
  );
  if (!gameLog) {
    return null;
  }
  const stats = calculateSeasonStats([gameLog]);
  const userClubStats = stats?.userClubStats;
  const opponentClubStats = stats?.opponentClubStats;
  const passingStats = stats?.passingStats;
  const rushingStats = stats?.rushingStats;
  const receivingStats = stats?.receivingStats;
  const defenseStats = stats?.defenseStats;
  const gamesPlayed = 1;

  const userClub =
    gameLog.game.home_club.id === club?.id
      ? gameLog.game.home_club
      : gameLog.game.away_club;
  const opponentClub =
    userClub.id === gameLog.game.home_club.id
      ? gameLog.game.away_club
      : gameLog.game.home_club;

  return (
    <Box sx={{ width: "100%" }}>
      <QuickNavigation />

      <Box sx={{ mt: 3 }}>
        <SectionContainer id="team-overview" title="Team Overview">
          <GameTeam
            userClubStats={userClubStats}
            opponentClubStats={opponentClubStats}
            gamesPlayed={gamesPlayed}
            userClub={userClub}
            opponentClub={opponentClub}
          />
        </SectionContainer>

        <SectionContainer id="offense" title="Offense">
          <Stack spacing={3}>
            <Box>
              <Passing passingStats={passingStats} />
            </Box>
            <Box>
              <Rushing rushingStats={rushingStats} />
            </Box>
            <Box>
              <Receiving receivingStats={receivingStats} />
            </Box>
          </Stack>
        </SectionContainer>

        <SectionContainer id="defense" title="Defense">
          <Defense defenseStats={defenseStats} />
        </SectionContainer>

        <SectionContainer id="special-teams" title="Special Teams">
          <Stack spacing={3}>
            <Box>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Field Goals
              </Typography>
              <Typography>
                Field goal and extra point stats will go here
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Tackles
              </Typography>
              <Typography>Special teams tackle stats will go here</Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Returns
              </Typography>
              <Typography>Kick and punt return stats will go here</Typography>
            </Box>
          </Stack>
        </SectionContainer>
      </Box>
    </Box>
  );
};
